import { CourtsList } from 'modules/arena/settings/components/CourtsList';
import { TeamList } from 'modules/arena/settings/components/TeamList';
import { CancellationPolicyCard } from 'modules/arena/settings/components/CancellationPolicyCard';
import { PlanSummaryCard } from 'modules/arena/settings/components/PlanSummaryCard';

export function ArenaSettingsPage() {
  return (
    <div className="flex-1 p-6">
      <h1 className="font-heading text-xl font-bold text-ink">Quadras e equipe</h1>
      <p className="text-sm text-ink-secondary">
        Configurações da unidade: quadras, equipe, cancelamento e plano SaaS.
      </p>

      <div className="mt-6 grid gap-6 lg:grid-cols-2">
        <div className="flex flex-col gap-6">
          <CourtsList />
          <TeamList />
        </div>
        <div className="flex flex-col gap-6">
          <CancellationPolicyCard />
          <PlanSummaryCard />
        </div>
      </div>
    </div>
  );
}
